<template>
  <b-modal ref="request-modal" hide-footer class="text-center" centered>
    <template v-if="loading">
      {{ $t('dashboard.accountNumbers.requestModal.loading') }}
    </template>
    <template v-else>
      <p>{{ successMessage }}</p>
      <p>
        <b-button
          size="sm"
          class="m-auto"
          variant="primary"
          @click.prevent="hide"
        >
          {{ $t('dashboard.accountNumbers.requestModal.ok') }}
        </b-button>
      </p>
    </template>
  </b-modal>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      successMessage: ''
    }
  },
  methods: {
    show(
      request,
      successMessage = this.$t(
        'dashboard.accountNumbers.requestModal.successMessage'
      )
    ) {
      this.loading = true
      this.$refs['request-modal'].show()
      request()
        .then(() => {
          this.loading = false
          this.successMessage = successMessage
        })
        .catch((err) => {
          console.log(err)
        })
    },
    hide() {
      this.$refs['request-modal'].hide()
    }
  }
}
</script>
<style></style>
